import './listReject.scss';
import React, { useState, useEffect } from 'react';
import { Container, Button, Typography } from '@material-ui/core';
import { Grid } from '@material-ui/core';
import { Check, Search, ShoppingCart } from '@material-ui/icons';
import Emoji from "../../assets/Images/Emoji1.png";
import Emoji3 from "../../assets/Images/Emoji3.png";

const { REACT_APP_STRAPI_API_URL } = process.env;

function ListReject() {
    const [searchDomainTitle, setSearchDomainTitle] = useState();
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(
                    `${REACT_APP_STRAPI_API_URL}/api/search-domain-titles`
                );
                const json = await response.json();
                setSearchDomainTitle(json?.data[0]?.attributes);
            } catch (error) {
            }
        };
        fetchData();
    }, []);

    const [searchdomainnames, setsearchdomainnames] = useState();
    const getsearchdomainnamesData = async () => {
        const response = await fetch(
            `${REACT_APP_STRAPI_API_URL}/api/search-domain-names`
        ).then((response) => response.json());
        setsearchdomainnames(response?.data);
    };
    useEffect(() => {
        getsearchdomainnamesData();
    }, [])

    const [usBetters, setUsBetter] = useState();
    const getUsBetterData = async () => {
        const response = await fetch(
            `${REACT_APP_STRAPI_API_URL}/api/us-betters?populate=Image`
        ).then((response) => response.json());
        setUsBetter(response?.data);
    };
    useEffect(() => {
        getUsBetterData();
    }, [])

    const [buttons, setButton] = useState();
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(
                    `${REACT_APP_STRAPI_API_URL}/api/button-apis`
                );
                const json = await response.json();
                setButton(json?.data[0]?.attributes);
            } catch (error) {
            }
        };
        fetchData();
    }, []);

    return (
        <>
            <div class="borderboxwrap">
                <div class="title-col1">
                <Typography variant="h1">{searchDomainTitle?.title}</Typography>
                </div>
                <form class="searchcolwrap">
                    <input type="search" name="search" placeholder='Search'></input>
                    <Button class="btnstyle"><Search></Search>{buttons?.avax}</Button>
                </form>
                <section className='great'>
                    <Container>
                        <Grid>
                            <Grid container item xl={6} lg={6} md={6} sm={12} xs={12}>
                                <div className='domainboxwrap'>
                                    <div className='imgcolleft'><img src={Emoji} alt=" " class="img-responsive ML-10-MBL" /></div>
                                    <div className='imgcolright'>
                                        <Button class="btnstyle3">{buttons?.great}</Button>
                                        <Typography variant="h2">melissa5ire<span>.avax</span></Typography>
                                        <Typography variant="h4"><span>AVAX 19.99 </span>FOREVER YOURS</Typography>
                                        <Button class="btnregister"><Check></Check>{buttons?.register}</Button>
                                    </div>
                                </div>
                            </Grid>
                            <Grid container item xl={6} lg={6} md={6} sm={12} xs={12}>
                                <div className='domainboxwrap ml-52'>
                                    <div className='imgcolleft'><img src={Emoji3} alt=" " class="img-responsive ML-10-MBL" /></div>
                                    <div className='imgcolright'>
                                        <Button class="btnGreat">{buttons?.taken}</Button>
                                        <Typography variant="h2">Melissa<span>.avax</span></Typography>
                                        <Button class="btnSearch"><Search></Search>{buttons?.again}</Button>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Container>
                </section>
                <Container>
                    <div class="greataltwrap">
                        <Button class="btnstyle3">{searchDomainTitle?.bulkTitle}</Button>
                        <ul className='greaaltlist'>
                            {searchdomainnames && searchdomainnames.map(searchdomainname => (
                                <li>
                                    <div class="colleft">
                                        <Typography variant="h3">{searchdomainname.attributes.name}<span>.avax</span></Typography>
                                    </div>
                                    <div class="colright">
                                        <div class="infocol">
                                            {searchdomainname.attributes.value}
                                            <Typography variant="h6">{searchdomainname.attributes.content}</Typography>
                                        </div>
                                        <div class="rightcarticon">
                                            <ShoppingCart></ShoppingCart>
                                        </div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                </Container>
                <section className='usBetter'>
                    <Container>
                        <Grid item xs={12}>
                        <Typography variant="h1">{searchDomainTitle?.usbetterTitle}</Typography>
                        </Grid>
                        <Grid style={{ display: "flex", flexWrap: "wrap" }}>
                            {usBetters && usBetters.map(usBetter => (
                                <Grid container item xl={3} lg={3} md={3} sm={12} xs={12}>
                                    <div className='usBetterDetail'>
                                        <img src={REACT_APP_STRAPI_API_URL + usBetter?.attributes?.Image?.data[0]?.attributes.url} alt=" " class="img-fluid" />

                                        <Typography variant="h2">{usBetter.attributes.name}</Typography>
                                        <Typography component="p">{usBetter.attributes.content}</Typography>
                                    </div>
                                </Grid>
                            ))}
                        </Grid>
                    </Container>
                </section>
            </div>
        </>
    );
}
export default ListReject;
